const O = "user/LOGIN", s = "user/LOGOUT";
export {
  O as LOGIN,
  s as LOGOUT
};
//# sourceMappingURL=types.js.map
